module.exports = __webpack_public_path__ + "static/media/img-perfect-timing.c5bd6b7b.png";